(function () {
  function label(fs) {
    var name = fs.getAttribute('data-option') || '';
    if (/size|taille/i.test(name)) return; // Size is already handled
    var legend = fs.querySelector('legend');
    if (!legend) return;
    var existing = legend.querySelector('.js-value');
    if (existing && existing.textContent.trim()) return; // theme already shows it
    var checked = fs.querySelector('input.js-option:checked');
    if (!checked) return;
    var span = legend.querySelector('.c9-opt-val');
    if (!span) {
      span = document.createElement('span');
      span.className = 'c9-opt-val';
      span.style.fontWeight = '600';
      legend.appendChild(span);
    }
    span.textContent = ': ' + checked.value;
  }
  function update() {
    document.querySelectorAll('fieldset.option-selector[data-option]').forEach(label);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input.js-option')) setTimeout(update, 0);
  });
  document.addEventListener('on:variant:change', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
